import { render, staticRenderFns } from "./my-search-dict.vue?vue&type=template&id=59fcf7e2&scoped=true"
import script from "./my-search-dict.vue?vue&type=script&lang=js"
export * from "./my-search-dict.vue?vue&type=script&lang=js"
import style0 from "./my-search-dict.vue?vue&type=style&index=0&id=59fcf7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fcf7e2",
  null
  
)

export default component.exports